import * as z from 'zod'
import { MassMailing } from '~/shared/api'
import { Option, OptionEnum } from '~/shared/config/constants'
import { DriverStatus } from '~/shared/config/enums'

export const formSchema = MassMailing.schema.pick({
  name: true,
  title: true,
  content: true,
  isActive: true,
  scheduledAt: true,
  userStatuses: true,
  regionsIds: true,
})

export type SchemaType = z.infer<typeof formSchema>

export type FormValues = Omit<SchemaType, 'userStatuses' | 'regionsIds'> & {
  userStatuses?: DriverStatus[] | OptionEnum<DriverStatus>[]
  regionsIds?: UniqueId[] | Option[]
}
